import React from 'react';

// Renders the Tomatometer score with fresh/rotten styling. No title is shown.
export default function TomatometerBadge({ score, state }) {
  if (score === null || score === undefined) {
    return (
      <div className="mp-tomato mp-tomato--unknown" title="No critic score">
        <span className="mp-tomato-icon" aria-hidden>
          ?
        </span>
        <span className="mp-tomato-score">N/A</span>
      </div>
    );
  }
  const fresh = (state ? state.includes('fresh') : score >= 60);
  return (
    <div className={`mp-tomato ${fresh ? 'mp-tomato--fresh' : 'mp-tomato--rotten'}`}>
      <span className="mp-tomato-icon" aria-hidden>
        {fresh ? '🍅' : '🥬'}
      </span>
      <span className="mp-tomato-score">{score}%</span>
    </div>
  );
}
